/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import HomeView from 'src/views/pages/HomeView';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import RolGuard from 'src/components/RolGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: function () {
      return <Redirect to="/login" />
    }
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/set-new-pass/:token',
    component: lazy(() => import('src/views/auth/NewPassView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        excat: true,
        path: '/app/deviceMap',
        component: lazy(() => import('src/views/deviceMap'))
      },
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/account" />
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard',
        component: lazy(() => import('src/views/reports/DashboardView'))
      },
      {
        exact: true,
        path: '/app/reports/dashboardadmin',
        component: lazy(() => import('src/views/reports/DashboardAdmin'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard-alternative',
        component: lazy(() => import('src/views/reports/DashboardAlternativeView'))
      },
      {
        exact: true,
        path: '/app/reports',
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        excat: true,
        path: '/app/newsfeed',
        component: lazy(() => import('src/views/newsfeed'))
      },
      {
        exact: true,
        path: '/app/learning/videos',
        component: lazy(() => import('src/views/Learning/Videos'))
      },
      {
        exact: true,
        path: '/app/tickets',
        component: lazy(() => import('src/views/management/TicketListView'))
      },
      {
        exact: true,
        path: '/app/tickets/:ticketId/view',
        component: lazy(() => import('src/views/management/TicketListView'))
      },
      {
        exact: true,
        path: '/app/tickets/:ticketId/edit',
        component: lazy(() => import('src/views/management/TicketEditView'))
      },
      {
        exact: true,
        path: '/app/tickets/new',
        component: lazy(() => import('src/views/management/TicketEditView'))
      },
      {
        exact: true,
        path: '/app/map',
        component: () => <Redirect to="/app/DeviceMapView" />
      },
      {
        excat: true,
        path: '/app/DeviceMapView',
        component: lazy(() => import('src/views/management/DeviceMapView'))
      },
      {
        excat: true,
        path: '/app/EventMapView',
        component: lazy(() => import('src/views/management/EventMapView'))
      },
      {
        excat: true,
        path: '/app/EventMapNewView',
        component: lazy(() => import('src/views/management/EventMapNewView'))
      },
      {
        exact: true,
        path: '/app/calendar',
        component: lazy(() => import('src/views/calendar/CalendarView'))
      },
      {
        exact: true,
        path: '/app/management/abm/equipment',
        component: lazy(() => import('src/views/management/ABM/Equipment'))
      },
      {
        exact: true,
        path: '/app/management/abm/equipment/new',
        component: lazy(() => import('src/views/management/ABM/Equipment/Edit'))
      },
      {
        exact: true,
        path: '/app/management/abm/equipment/:equipmentId',
        component: lazy(() => import('src/views/management/ABM/Equipment/Edit'))
      },
      {
        guard: RolGuard,
        routes: [
          {
            exact: true,
            path: '/app/management/abm/vehicle',
            component: lazy(() => import('src/views/management/ABM/Vehicle'))
          },
          {
            exact: true,
            path: '/app/management/abm/vehicle/new',
            component: lazy(() => import('src/views/management/ABM/Vehicle/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/vehicle/:vehicleId',
            component: lazy(() => import('src/views/management/ABM/Vehicle/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/project',
            component: lazy(() => import('src/views/management/ABM/Project'))
          },
          {
            exact: true,
            path: '/app/management/abm/project/new',
            component: lazy(() => import('src/views/management/ABM/Project/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/project/import',
            component: lazy(() => import('src/views/management/ABM/Project/Import'))
          },
          {
            exact: true,
            path: '/app/management/abm/project/:projectId',
            component: lazy(() => import('src/views/management/ABM/Project/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/newsleter',
            component: lazy(() => import('src/views/management/ABM/Newsleter'))
          },
          {
            exact: true,
            path: '/app/management/abm/newsleter/new',
            component: lazy(() => import('src/views/management/ABM/Newsleter/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/newsleter/:newsleterId',
            component: lazy(() => import('src/views/management/ABM/Newsleter/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/user',
            component: lazy(() => import('src/views/management/ABM/User'))
          },
          {
            exact: true,
            path: '/app/management/abm/user/new',
            component: lazy(() => import('src/views/management/ABM/User/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/user/:userId',
            component: lazy(() => import('src/views/management/ABM/User/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/equipmentType',
            component: lazy(() => import('src/views/management/ABM/EquipmentType'))
          },
          {
            exact: true,
            path: '/app/management/abm/equipmentType/new',
            component: lazy(() => import('src/views/management/ABM/EquipmentType/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/equipmentType/:equipmentTypeId',
            component: lazy(() => import('src/views/management/ABM/EquipmentType/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/EquipmentBrand',
            component: lazy(() => import('src/views/management/ABM/EquipmentBrand'))
          },
          {
            exact: true,
            path: '/app/management/abm/EquipmentBrand/new',
            component: lazy(() => import('src/views/management/ABM/EquipmentBrand/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/EquipmentBrand/:Id',
            component: lazy(() => import('src/views/management/ABM/EquipmentBrand/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/EquipmentModel',
            component: lazy(() => import('src/views/management/ABM/EquipmentModel'))
          },
          {
            exact: true,
            path: '/app/management/abm/EquipmentModel/new',
            component: lazy(() => import('src/views/management/ABM/EquipmentModel/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/EquipmentModel/:Id',
            component: lazy(() => import('src/views/management/ABM/EquipmentModel/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/crashType',
            component: lazy(() => import('src/views/management/ABM/CrashType'))
          },
          {
            exact: true,
            path: '/app/management/abm/crashType/new',
            component: lazy(() => import('src/views/management/ABM/CrashType/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/crashType/:crashTypeId',
            component: lazy(() => import('src/views/management/ABM/CrashType/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/crashSeverity',
            component: lazy(() => import('src/views/management/ABM/CrashSeverity'))
          },
          {
            exact: true,
            path: '/app/management/abm/crashSeverity/new',
            component: lazy(() => import('src/views/management/ABM/CrashSeverity/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/crashSeverity/:crashSeverityId',
            component: lazy(() => import('src/views/management/ABM/CrashSeverity/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/videoFeed',
            component: lazy(() => import('src/views/management/ABM/VideoFeed'))
          },
          {
            exact: true,
            path: '/app/management/abm/videoFeed/new',
            component: lazy(() => import('src/views/management/ABM/VideoFeed/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/videoFeed/:videoFeedId',
            component: lazy(() => import('src/views/management/ABM/VideoFeed/Edit'))
          }
        ]
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/home',
        component: HomeView
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
